import React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { LoginPage, useAuth } from "../libs/auth";
import Shell from "../libs/shell";
import { logOut } from "../libs/auth/store/auth.slice";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks/app-store.hook";
import Dashboard from "../feature/dashboard";
import { NotFoundPage } from "../libs/core";
import UserManager from "../feature/users";
import BlogManager from "../feature/blogs";
import TeamProfileManager from "../feature/team";
import SubscribersManager from "../feature/newsletter";
import ProfilePage from "../feature/dashboard/profile_page";
import BlogDetailPage from "../feature/blogs/blog_details";
import TestimonialList from "../feature/testimonials";
import PartnerManager from "../feature/partners";
import UnitTypeManager from "../feature/UnitTypes";
import ContactUsManager from "../feature/ContactUs";
import NewsLetterManager from "../feature/newsletter/news_letter_manager";
import NewsletterDetailPage from "../feature/newsletter/newsletter_detail";
import GalleryManager from "../feature/galleries";
import GalleryDetailPage from "../feature/galleries/components/GalleryDetail";
import ProgramManager from "../feature/programs";
import ProgramDetailPage from "../feature/programs/components/ProgramDetail";
import ImpactManager from "../feature/impacts";
import ImpactDetailPage from "../feature/impacts/impact-detail";
import VolunteerManager from "../feature/volunteers";
import VolunteerDetailPage from "../feature/volunteers/volunteer-detail";
import VacancyManager from "../feature/vacancies";
import VacancyDetailPage from "../feature/vacancies/vacancy-detail-page";
import CSOManager from "../feature/cso";
import ResourceDocumentManager from "../feature/resourceDocuments";

export const Routing = (): JSX.Element => {
    /* hooks */
    const { session } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

  
    const localSession = localStorage.getItem("session");
  
    useEffect(() => {
      if (!session || !localSession) {
        dispatch(logOut());
        navigate("/login");
      } else if (session && location.pathname === "/login") {
        navigate("/");
      }
    }, [session, location.pathname, navigate, dispatch, localSession]);
  
    return (
      <>
        {/* <ScrollRestoration /> */}
        <Routes>
          {session === null && <Route path="/login" element={<LoginPage />} />}
  
          {session !== null && (
            <Route path="/" element={<>{<Shell />}</>}>
              <Route index element={<Dashboard/>}/>
              <Route path="/users" element={<UserManager/>} />
              <Route path="/blogs" element={<BlogManager/>} />
              <Route path="/galleries" element={<GalleryManager/>} />
              <Route path="/galleries/:id" element={<GalleryDetailPage/>} />
              <Route path="/programs" element={<ProgramManager/>} />
              <Route path="/programs/:id" element={<ProgramDetailPage/>} />
              <Route path="/impacts" element={<ImpactManager/>} />
              <Route path="/impacts/:id" element={<ImpactDetailPage/>} />
              <Route path="/volunteers" element={<VolunteerManager/>} />
              <Route path="/volunteers/:id" element={<VolunteerDetailPage/>} />
              <Route path="/vacancies" element={<VacancyManager/>} />
              <Route path="/vacancies/:id" element={<VacancyDetailPage/>} />
              <Route path="/testimonials" element={<TestimonialList/>} />
              <Route path="/teams" element={<TeamProfileManager/>} />
              <Route path="/subscribers" element={<SubscribersManager/>} />
              <Route path="/profile" element={<ProfilePage/>} />
              <Route path="/blogs/:id" element={<BlogDetailPage/>} />
              <Route path="/partners" element={<PartnerManager/>} />
              <Route path="/unit-types" element={<UnitTypeManager/>} />
              <Route path="/messages" element={<ContactUsManager/>} />
              <Route path="/newsletters" element={<NewsLetterManager/>} />
              <Route path="/newsletters/:id" element={<NewsletterDetailPage/>} />
              <Route path="/cso-members" element={<CSOManager/>} />
              <Route path="/resource-documents" element={<ResourceDocumentManager/>} />
            </Route>
          )}

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    );
  };